import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';

/**
 * Logs the user out of the application.
 *
 * The component supports two authentication flows:
 * 1. Auth0 based login – we call the Auth0 SDK's logout method.
 * 2. Manual "simple" admin login – we simply remove the stored JWT token
 *    and redirect the user to the dedicated login page.
 */
const LogoutButton: React.FC = () => {
  const { logout, isAuthenticated } = useAuth0();

  const handleLogout = () => {
    const manualToken =
      typeof localStorage !== 'undefined'
        ? localStorage.getItem('token')
        : null;

    // Always remove the manual token so a fresh login is required next time.
    if (manualToken && typeof localStorage !== 'undefined') {
      localStorage.removeItem('token');
    }

    if (isAuthenticated) {
      // Logged in via Auth0 – delegate logout to the SDK which also clears
      // the session at Auth0 and returns the user to our app's root.
      logout({ logoutParams: { returnTo: window.location.origin } });
    } else if (manualToken) {
      // Manual admin login – simply redirect to the simple login page.
      window.location.href = '/simple-admin-login';
    } else {
      // Fallback: redirect to app root.
      window.location.href = '/';
    }
  };

  return (
    <button
      onClick={handleLogout}
      className='px-3 py-2 text-sm text-white bg-gray-700 rounded hover:bg-gray-800'
    >
      Logout
    </button>
  );
};

export default LogoutButton;
